import React, { useState } from 'react'
import { Button, Form, InputGroup } from 'react-bootstrap'
import { Link } from 'react-router-dom';
import { FiArrowLeft, FiPlus, FiUsers } from 'react-icons/fi';
import SideBar from '../../../components/sidebar/Sidebar';
import { toast } from 'react-hot-toast'
import { FaCross } from 'react-icons/fa'
import { useCreateUrlHook } from './hook'
import { BsEyeFill, BsEyeSlashFill } from "react-icons/bs";
const CreateClientSCreen = () => {

    const [client, setClient] = useState({
        client_name: "",
        description: "",
        password: "",
        confirm_password: "",
        mobile: ""
    })

    const [viewPassword, setViewPassword] = useState(false)
    const [viewConfirmPassword, setViewConfirmPassword] = useState(false)


    const handleInputs = (e) => {
        const name = e.target.name;
        const value = e.target.value
        setClient({ ...client, [name]: value })
    }

    const { doSubmitUrl } = useCreateUrlHook();

    const handleSubmit = (e) => {
        const { client_name, description, password, confirm_password, mobile } = client;
        e.preventDefault();
        if (confirm_password === password) {
            doSubmitUrl({
                username: client_name,
                description: description,
                mobile,
                password,
                role: 'client'
            });
            setClient({
                client_name: "",
                description: "",
                password: "",
                confirm_password: "",
                mobile: ""
            })
        } else {

            toast("Passwords does not match", {
                duration: 2000,
                icon: <FaCross />,
                style: {
                    backgroundColor: "#ffabcd",
                    fontSize: 14,
                },
            });

        }

    }

    return (
        <SideBar>
            <section className="create-page user-create-page" aria-labelledby="user-create-title">
                <Link className="user-back-link" to="/user-list"><FiArrowLeft aria-hidden="true" />Clients</Link>
                <header className="create-page-header">
                    <span className="create-page-icon" aria-hidden="true"><FiUsers /></span>
                    <h1 id="user-create-title">Create client</h1>
                </header>
                                <Form className="create-form" onSubmit={handleSubmit}>
                                  <div className="create-form-grid">
                                    <Form.Group className="create-field" controlId="client-username">
                                        <Form.Label>Username</Form.Label>
                                        <Form.Control
                                            type="text"
                                            value={client.client_name}
                                            name='client_name'
                                            // onChange={handleInputs}
                                            onChange={(e) => {
                                                const disallowedCharacters = "+@#$&%!~=^_:(){}[]|/*.\\g-?<>,;`'\"";
                                                if (![...e.target.value].some((character) => disallowedCharacters.includes(character)) && e.target.value.trim()) {
                                                    handleInputs(e)
                                                }
                                                else if (e.target.value.length === 0) {
                                                    handleInputs(e)
                                                }
                                            }}
                                        />

                                    </Form.Group>
                                    <Form.Group className="create-field" controlId="client-mobile">
                                        <Form.Label>Mobile no</Form.Label>
                                        <Form.Control type="number" value={client.mobile} name='mobile' onChange={handleInputs} />
                                    </Form.Group>
                                    <Form.Group className="create-field" controlId="client-password">
                                        <Form.Label>Password</Form.Label>
                                        <InputGroup className="mb-3">
                                            <Form.Control type={viewPassword ? "text" : "password"} value={client.password} name='password' onChange={handleInputs} />
                                            <Button type="button" className="user-password-toggle" aria-label={viewPassword ? 'Hide password' : 'Show password'} title={viewPassword ? 'Hide password' : 'Show password'} onClick={() => setViewPassword(!viewPassword)}>{viewPassword ? <BsEyeFill /> : <BsEyeSlashFill />}</Button>
                                        </InputGroup>
                                    </Form.Group>
                                    <Form.Group className="create-field" controlId="client-confirm-password">
                                        <Form.Label>Confirm Password</Form.Label>
                                        <InputGroup className="mb-3">
                                            <Form.Control type={viewConfirmPassword ? "text" : "password"} value={client.confirm_password} name='confirm_password' onChange={handleInputs} />
                                            <Button type="button" className="user-password-toggle" aria-label={viewConfirmPassword ? 'Hide confirm password' : 'Show confirm password'} title={viewConfirmPassword ? 'Hide confirm password' : 'Show confirm password'} onClick={() => setViewConfirmPassword(!viewConfirmPassword)}>{viewConfirmPassword ? <BsEyeFill /> : <BsEyeSlashFill />}</Button>
                                        </InputGroup>

                                    </Form.Group>
                                    <Form.Group className="create-field create-field-wide" controlId="client-description">
                                        <Form.Label>Description</Form.Label>
                                        <Form.Control as="textarea" rows={3} value={client.description} name="description" onChange={handleInputs} />
                                    </Form.Group>
                                  </div>
                                  <div className="create-form-actions user-form-actions">
                                    <Link className="user-cancel-link" to="/user-list">Cancel</Link>
                                    <button className="create-submit" type="submit"><FiPlus aria-hidden="true" />Create client</button>
                                  </div>
                                </Form>
            </section>
        </SideBar>
    )
}

export default CreateClientSCreen